<template>
  <div class="form-group">
    <label v-if="label">{{ label }}</label>
    <input 
      v-model="iValue" 
      type="text" 
      class="form-control" 
      inputmode="numeric"
      @input="handleInput"
      @blur="handleBlur"
    >
  </div>
</template>

<script>
export default {
  props: {
    label: {
      required: false,
      type: [String, null],
      default: '',
    },

    value: {
      required: false,
      type: [String, Number],
      default: 0,
    },
  },

  data() {
    return {
      localValue: '0',
    }
  },

  computed: {
    iValue: {
      get() {
        return this.localValue
      },
      set(newValue) {
        this.localValue = newValue
      },
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        // Initialize with 0 if value is empty or null
        const val = (newVal === '' || newVal === null || newVal === undefined) ? 0 : newVal
        this.localValue = String(val)
      }
    }
  },

  mounted() {
    // Ensure default value is 0 if not provided
    if (this.value === '' || this.value === null || this.value === undefined) {
      this.$emit('input', 0)
    }
  },

  methods: {
    handleInput(event) {
      const value = event.target.value
      // Allow only digits
      const digitsOnly = value.replace(/\D/g, '')
      
      // Update local value with digits only
      this.localValue = digitsOnly || '0'
      
      // Emit numeric value
      const numericValue = parseInt(digitsOnly || '0', 10)
      this.$emit('input', numericValue)
    },

    handleBlur() {
      // Ensure there's always at least 0 on blur
      if (this.localValue === '' || this.localValue === null) {
        this.localValue = '0'
        this.$emit('input', 0)
      }
    }
  },
}
</script>

<style scoped>
.form-control {
  font-weight: 600;
}
</style>